import styled from 'styled-components';
import { css } from '@styled-system/css';

import { theme } from 'utils/theme.v2';
import { inputCheckboxProps } from 'humanity/components/inputCheckbox/inputCheckbox.types.js';

const StyledLabel = styled.label(
  css({
    color: theme.colors.blue100,
    display: 'grid',
    gridTemplateColumns: '2em auto',
    alignItems: 'center',
    gap: 2,
    mt: 2,
  })
);

const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })(
  css({
    /* Remove most all native input styles */
    appearance: 'none',
    /* For iOS < 15 */
    backgroundColor: 'transparent',
    /* Not removed via appearance */
    margin: 0,
    width: '24px',
    height: '24px',
    border: `3px solid ${theme.colors.gray40}`,
    borderRadius: '4px',
    transform: 'translateY(-0.075em)',
    display: 'grid',
    placeContent: 'center',

    '&:checked': {
      color: 'white',
      border: `none`,
      // boxShadow: `inset 2em 2em ${theme.colors.teal40}`,
      backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="4" fill="%2315A29B"/><path d="M6.99924 12.0711L10.5348 15.6066L17.6058 8.53553" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>')`,
    },
    '&:disabled': {
      color: `${theme.colors.gray20}`,
      boxShadow: `inset 2em 2em ${theme.colors.gray20}`,
      cursor: 'not-allowed',
      borderColor: theme.colors.gray20,
    },
  })
);
const InputCheckbox = ({ id, text, checkboxProps, ...props }) => (
  <StyledLabel {...props}>
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <StyledCheckbox id={id} name={id} {...checkboxProps} />
    {text}
  </StyledLabel>
);

InputCheckbox.propTypes = {
  ...inputCheckboxProps,
};

export default InputCheckbox;
